export const formatFileSize = (fileSize?: string): string | undefined => {
    const trimmed = fileSize?.trim();
    if (!trimmed) {
        return undefined;
    }
    const sizeInKb = Number(trimmed.replace(',', '.'));
    return Number.isFinite(sizeInKb) ? `${Number(sizeInKb.toFixed(2))}KB` : trimmed;
};
